( function( $ ) {
	var $reviewForm = $( '#write-a-review' ),
		$verticalSelect = $( '#vertical-select' ),
		$brandSelect = $( '#brand-select' ),
		$productSelect = $( '#product-select' );

	var vertical = $verticalSelect.find( 'option:selected' ).val(),
		brand = $brandSelect.find( 'option:selected' ).val();

	function getSelectOptions( data ) {
		$.ajax( {
			type: 'post',
			dataType: 'json',
			url: igniteBase.ajaxurl,
			data: data,
			success: function( response ) {
				if ( response.type == 'success' ) {
					if ( data.action === 'ignite_base_brands_by_vertical' ) {
						$brandSelect.append( response.options );
						$brandSelect.prop( 'disabled', false );
					} else {
						$productSelect.append( response.options );
						$productSelect.prop( 'disabled', false );
					}
				}
				else {
					alert( 'There was an issue.' );
				}
			}
		} );
	}

	function postReview( data ) {
		console.log(data);
		$.ajax( {
			type: 'post',
			dataType: 'json',
			url: igniteBase.ajaxurl,
			data: data,
			success: function( response ) {
				if ( response.type == 'success' ) {
					clearReviewForm();
					$( '.js-reviews-capture-form__message' ).addClass( 'success' ).html( '<p>Thanks for your review! We\'ll take a look and display it on the site.</p>' );
				}
				else {
					$( '.js-reviews-capture-form__message' ).addClass( 'error' ).html( '<p>There was an issue submitting the form.</p>' );
				}
			}
		} );
	}

	function clearReviewForm() {
		$verticalSelect.val( '' );
		$brandSelect.find( 'option:not(:first-child)' ).remove();
		$productSelect.find( 'option:not(:first-child)' ).remove();
		$reviewForm.find( '[name=review-title]' ).val( '' );
		$reviewForm.find( '[name=rating]:checked' ).prop( 'checked', false );
		$reviewForm.find( '[name=review-text]' ).val( '' );
		$reviewForm.find( '[name=full-name]' ).val( '' );
		$reviewForm.find( '[name=email-address]' ).val( '' );
		$reviewForm.find( '[name=who]' ).val( '' );
		$reviewForm.find( '[name=zip]' ).val( '' );
		$reviewForm.find( '[name=agree]' ).prop( 'checked', false );
		$( 'html, body' ).animate( { scrollTop: 0 }, 300 );
	}

	$verticalSelect.change( function() {
		var selected = $( this ).find( 'option:selected' ).val();
		if ( selected !== vertical ) {
			// vertical changed and brand and product options no longer apply
			$brandSelect.find( 'option:not(:first-child)' ).remove();
			$productSelect.find( 'option:not(:first-child)' ).remove();
			vertical = selected;
			var data = {
				action: 'ignite_base_brands_by_vertical',
				vertical: vertical
			};
			getSelectOptions( data );
		}
	} );

	$brandSelect.change( function() {
		var selected = $( this ).find( 'option:selected' ).val();
		if ( selected !== brand ) {
			// brand changed and product options no longer apply
			$productSelect.find( 'option:not(:first-child)' ).remove();
			brand = selected;
			var data = {
				action: 'ignite_base_product_by_brand',
				vertical: vertical,
				brand: brand
			};
			getSelectOptions( data );
		}
	} );

	$reviewForm.submit( function( e ) {
		e.preventDefault();
		var data = {
			action: 'ignite_base_add_review',
			ip: $( '[name=ip]' ).val(),
			duplicatedIP: $( '[name=duplicated-ip]' ).val(),
			vertical: $( '[name=vertical] option:selected' ).val(),
			brand: $( '[name=brand] option:selected' ).val(),
			product: $( '[name=product] option:selected' ).val(),
			reviewTitle: $( '[name=review-title]' ).val(),
			rating: $( '[name=rating]:checked' ).val(),
			reviewText: $( '[name=review-text]' ).val(),
			fullName: $( '[name=full-name]' ).val(),
			emailAddress: $( '[name=email-address]' ).val(),
			who: $( '[name=who]' ).val(),
			zip: $( '[name=zip]' ).val(),
			agree: $( '[name=agree]' ).val()
		};
		postReview( data );
	} );
} )( jQuery );



// WEBPACK FOOTER //
// ./assets/js/partials/review-capture-form.js